import React from 'react';

import {isTranslate} from 'shared/lib/lang';

interface WebhookProps {
    color?: 'colored' | 'gray';
}

const Webhook: React.FC<WebhookProps> = ({color = 'colored'}) => {
    const fill = color === 'gray'
        ? '#899696'
        : (isTranslate() ? '#3A68E2' : '#1DB5B6');

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* связи между узлами */}
            <path
                d="M8 4.6V7.2L4.7 11.2M8 7.2L11.3 11.2"
                stroke={fill}
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* узлы */}
            <circle cx="8" cy="3" r="2.4" fill={fill} />
            <circle cx="3.4" cy="12.4" r="2.4" fill={fill} />
            <circle cx="12.6" cy="12.4" r="2.4" fill={fill} />
        </svg>
    );
};

export default Webhook;
